<mat-tab-group
  dir="rtl"
  [class]="class"
  (selectedTabChange)="selectedTabChange.emit($event)"
  dynamicHeight="false"
  >
  @for (tab of tabs; track tab) {
    <mot-tab [tab]="tab"></mot-tab>
  }
</mat-tab-group>
